export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/cartoon_pattern.b0b0728.svg";